import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ERPDocumentService } from 'src/app/services/ERPDocumentService.service';
import { PurchasesService } from 'src/app/services/purchases.service';

@Component({
  selector: 'app-provider-chronology-report',
  templateUrl: './provider-chronology-report.component.html',
  styleUrls: ['./provider-chronology-report.component.scss']
})
export class ProviderChronologyReportComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  warehouse = null;
  @Input() warehouses: WarehouseResponse[] = [];
  loadingChart = false;
  results = [];

  constructor(
    private toastService: ToastrService,
    private purchaseService: PurchasesService
  ) {

  }

  ngOnInit(): void {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
    this.updateChart();
  }


  updateChart() {
    this.loadingChart = true;
    document.getElementById("provider-chronology")['innerHTML'] = "";
    this.purchaseService.getProviderChronology(
      this.warehouse,
      DateUtil.parseDateToMilliseconds(this.start),
      DateUtil.parseDateToMilliseconds(this.end)
    ).subscribe({
      next: (response: ResponseObject) => {
        this.results = response.data;
        this.results.forEach((r) => {
          r.day = new Date(r.day).toISOString().split("T")[0];
        })
        this.buildChart();
        this.loadingChart = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingChart = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  buildChart() {
    var response = this.results;
    var data = [];
    var categories = [];
    response.forEach((r) => {
      categories.push(r.day);
      data.push(r.total);
    })
    const options = {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: 'smooth'
      },
      series: [{
        name: 'Inventario',
        data: data
      }],
      xaxis: {
        type: 'Días',
        categories: categories,
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return MathUtil.formatCurrency(val);
          }
        }

      },
      legend: {
        offsetY: -10,
      }
    }
    if (this.results.length > 0) {
      const chart = new ApexCharts(
        document.querySelector("#provider-chronology"),
        options
      );
      chart.render();
    } else {
      this.results = [];
    }
  }

}